import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const UploadRegulatoryAdminStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .file-download-link {
    margin-bottom: 20px;
  }

  .upload-log-outter-wrapper {
    flex: 0 0 500px;
    max-width: 500px;
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
    background-color: white;
    min-width: 250px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    padding: 8px 14px;

    .upload-log-wrapper {
      width: calc(100% + 5px);
      height: 100%;
      overflow-y: auto;
      margin-right: -5px;

      span {
        color: ${VARIABLES.COLORS.BLUE_1};

        &.error {
          color: ${VARIABLES.COLORS.RED_3};
        }

        &.success {
          color: ${VARIABLES.COLORS.GREEN_1};
        }
      }

      /* width */
      ::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const UploadRegulatoryBuyerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .file-download-link {
    margin-bottom: 20px;
  }

  a {
    color: #4b4acb;
    text-decoration: underline;
  }

  .upload-wrapper {
    margin-bottom: 10px;
  }
  .lists-wrapper {
    overflow-y: scroll;
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    flex-wrap: wrap;
    margin-right: -13px;
    max-width: 510px;
    min-width: 250px;
    min-height: 250px;
    max-height: 250px;
    padding-right: 5px;
    align-items: flex-start;
    align-content: flex-start;

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
      margin-right: -13px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }
  .upload-log-outter-wrapper {
    flex: 0 0 500px;
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
    background-color: white;
    max-width: 500px;
    min-height: 250px;
    min-width: 250px;
    max-height: 300px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    padding: 8px 14px;
    margin-top: 10px;

    .upload-log-wrapper {
      height: 100%;
      overflow-y: auto;
      margin-right: -5px;

      span {
        color: ${VARIABLES.COLORS.BLUE_1};

        &.error {
          color: ${VARIABLES.COLORS.RED_3};
        }

        &.success {
          color: ${VARIABLES.COLORS.GREEN_1};
        }
      }

      /* width */
      ::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .section {
      &.form-wrapper {
        .form-group {
          .form-group-control {
            max-width: none;
          }

          .form-group-inner-wrapper {
            .button {
              flex: 0 0 120px;
            }
          }
        }
      }
    }

    .upload-log-outter-wrapper {
      min-height: 0;
      height: 252px;
      padding: 5px 14px;
      font-size: 16px;
    }

    .lists-wrapper {
      min-height: 240px;
      max-height: 240px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .section {
      &.form-wrapper {
        .form-group {
          .form-group-inner-wrapper {
            .button {
              flex: 0 0 115px;
            }
          }
        }
      }
    }

    .upload-log-outter-wrapper {
      height: 242px;
      font-size: 15px;
    }

    .lists-wrapper {
      min-height: 230px;
      max-height: 230px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .section {
      &.form-wrapper {
        .form-group {
          .form-group-inner-wrapper {
            .button {
              flex: 0 0 110px;
            }
          }
        }
      }
    }

    .upload-log-outter-wrapper {
      height: 232px;
      font-size: 14px;
    }

    .lists-wrapper {
      min-height: 220px;
      max-height: 220px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .section {
      &.form-wrapper {
        .form-group {
          max-width: none;

          .form-group-inner-wrapper {
            .button {
              flex: 0 0 105px;
            }
          }
        }
      }
    }

    .upload-log-outter-wrapper {
      height: 212px;
      font-size: 13px;
    }

    .lists-wrapper {
      min-height: 200px;
      max-height: 200px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .section {
      &.form-wrapper {
        .form-group {
          .form-group-inner-wrapper {
            .button {
              flex: 0 0 100px;
            }
          }
        }
      }
    }

    .upload-log-outter-wrapper {
      height: 192px;
      font-size: 12px;
    }

    .lists-wrapper {
      min-height: 180px;
      max-height: 180px;
    }
  }
`
